
$('.js-hint-product-link').each(function () {
    const $link = $(this);
    const $hint = $('.js-hint-product', $link);
    const $img = $('[data-src]', $hint);

    $link
        .one('mouseenter', function () {
            $img[0].src = $img.data('src');
        })
        .on('mouseenter', function () {
            $hint.addClass('_hover');
        })
        .on('mouseout', function () {
            $hint.removeClass('_hover');
        });
});

$('.js-hint-toggler').each(function () {
    const $link = $(this);
    const $hint = $('.js-hint-box', $link);
    const $img = $('[data-src]', $hint);

    $link
        .one('mouseenter', function () {
            if ($img.length) {
                $img[0].src = $img.data('src');
            }
        })
        .on('mouseenter', function () {
            $hint.addClass('_hover');
            $hint.attr('data-hint-pos', hintPosition($hint));
        })
        .on('mouseout', function () {
            $hint.removeClass('_hover');
        });
});

function hintPosition($hint) {console.log($hint.attr('data-hint-pos'));
    if ($hint.attr('data-hint-pos') == 'tc') return $hint.attr('data-hint-pos');

    const $toggler = $hint.closest('.js-hint-toggler');
    const props = $toggler[0].getBoundingClientRect();
    let x = 'r';
    let y = 'b';

    if (props.x > document.documentElement.clientWidth - $hint.outerWidth() - $toggler.outerWidth()) {
        x = 'l';
    }

    if (props.y > document.documentElement.clientHeight - $hint.outerHeight() - 50) {
        y = 't';
    }

    // если внутри слайдера перекрывается overflow hidden
    $toggler.closest('.swiper-container').each(function (i, swiper) {
        console.log($(swiper).offset().top + $(swiper).height() , $toggler.offset().top + $hint.outerHeight());
        if ($(swiper).offset().top + $(swiper).height() < $toggler.offset().top + $hint.outerHeight()) {
            y = 't';
        }
    });

    return x + y;
}
